import { v4 as uuidv4 } from 'uuid';

const getRefId = (): string => 'ref_' + uuidv4();

export default getRefId;
